export function formatCurrencyValue(cents = 0, currency = "eur") {
  return (cents / 100).toLocaleString("en-GB", {
    style: "currency",
    currency: currency.toUpperCase()
  });
}

export function getAgeFromDobValue(value) {
  const dob = new Date(value);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dayDiff = today.getDate() - dob.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export function validateAdultDobValue(value, minimumAge = 16) {
  if (!value) {
    return false;
  }

  return getAgeFromDobValue(value) >= minimumAge;
}